<template>
  <div class="phone-card fn-14">
    <div v-if="!loading" class="d-flex phone-item">
      <div class="phone-head" v-if="phone.type == 'mobile_number'">
        <!-- <i class="fa fa-mobile" title="Mobile Number" aria-hidden="true"></i> -->
        <Personal-Icon viewBox="5 0 34 35" />
        <span class="phone-title">Mobile Number</span>
      </div>
      <div class="phone-head" v-if="phone.type == 'direct_line'">
        <Direct-Dial-Icon
          viewBox="2 7 22 8"
          width="14px"
          height="14px"
          class="fill-blue"
        />
        <span class="phone-title">Direct Dial</span>
      </div>
      <div class="phone-head" v-if="phone.type == 'company_line'">
        <Company-Icon class="fill-blue" />
        <span class="phone-title">Company Number</span>
      </div>
      <div class="phone-head" v-if="phone.type == 'other'">
        <Direct-Dial-Icon
          viewBox="2 7 22 8"
          width="14px"
          height="14px"
          class="fill-blue"
        />
        <span class="phone-title">Other Number</span>
      </div>
      <div class="fn-14 icon-img-spacing noselect">{{ phone.number }}</div>
    </div>
    <div v-else class="flex-c">
      <div class="icon-hldr linear-background"></div>
      <div class="fn-14 icon-img-spacing linear-background"></div>
    </div>
  </div>
</template>

<script>
import companyIcon from './../../assets/icons/svg/company.svg'
import personalIcon from './../../assets/icons/svg/personal-call.svg'
import directDialIcon from './../../assets/icons/svg/direct-dial-icon.svg'
export default {
  name: 'CustomWebsitePhoneCard',
  props: ['phone', 'loading'],
  components: {
    'Company-Icon': companyIcon,
    'Direct-Dial-Icon': directDialIcon,
    'Personal-Icon': personalIcon
  }
}
</script>

<style scoped lang="scss">
.phone-card {
  @extend .flex-c;
  padding-right: 15px;
  .icon-img-spacing {
    margin: 0 0 0 30px;
    color: $primary-color;
    font-size: 14px;
  }
  .fill-blue {
    fill: $primary-color;
  }
  .phone-item {
    align-items: flex-start;
    flex-direction: column;
  }
  .phone-head {
    display: flex;
    align-items: center;
  }
  .phone-title {
    margin-left: 12px;
  }
}
</style>
